module.exports = __webpack_public_path__ + "static/img/workSite3.567736d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/workSite3.png
// module id = dqJN
// module chunks = 1